@defer (when onboarding.showModal()) {
  <app-onboarding-modal></app-onboarding-modal>
}
<router-outlet></router-outlet>
<app-web3-error-toast></app-web3-error-toast>
